import { io } from 'socket.io-client';
import { eventBus } from 'services';

const baseURL = process.env.REACT_APP_URL_BROADCAST as string;

const socket = io(baseURL, {});

socket.on('connect', () => {
  const engine = socket.io.engine;
  console.log('Socket engine:', engine.transport.name);
  engine.once('upgrade', () => {
    console.log('Socket engine upgraded:', engine.transport.name);
  });
});

socket.on('logout', (data: any) => {
  eventBus.dispatch<number>('logoutUserById', data?.userId);
});
